import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Feel Free to Discuss Your App Idea!</h2>
                        </div>
                        <p>At TekRevol, we acknowledge the ever-changing landscape of cross-platform app development. Whether you seek extensive support for cross-platform app development or advice on revitalizing existing apps. Connect with us now for inventive solutions and a revolutionary experience. As part of our commitment, we offer a free consultation to help you kickstart your journey without confusion. So, let’s get started.</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;